import classNames from 'classnames';
import * as React from 'react';
import styles from './Spinner.module.scss.js';

var Spinner = function (props) { return (React.createElement("div", { className: classNames(styles.container, props.className) },
    React.createElement("div", { className: styles.spinner }),
    props.label && React.createElement("div", { className: styles.label }, props.label))); };

export { Spinner as default };
//# sourceMappingURL=Spinner.js.map
